import { cva } from '@/styled-system/css';

export const toggleButtonRecipe = cva({
  base: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease, background-color 200ms ease',
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
      },
      false: {
        cursor: 'pointer',
      },
    },
    loading: {
      true: {},
      false: {},
    },
    selected: {
      true: {
        boxShadow: {
          base: 'inset 0 0 0 {borderWidths.ToggleButton.selected} var(--shadow-color)',
          _focusVisible:
            'inset 0 0 0 {borderWidths.ToggleButton.selected} var(--shadow-color), {shadows.focus}',
        },
        backgroundColor: {
          base: 'ToggleButton.bg.selected',
          _notDisabled: {
            _hover: 'ToggleButton.bg.selectedHover',
            _active: 'ToggleButton.bg.selectedPressed',
          },
        },
        boxShadowColor: {
          base: 'ToggleButton.border.selected',
          _notDisabled: {
            _hover: 'ToggleButton.border.selectedHover',
            _active: 'ToggleButton.border.selectedPressed',
          },
        },
      },
      false: {
        boxShadow: {
          base: 'inset 0 0 0 {borderWidths.ToggleButton.default} var(--shadow-color)',
          _focusVisible:
            'inset 0 0 0 {borderWidths.ToggleButton.default} var(--shadow-color), {shadows.focus}',
        },
        backgroundColor: {
          base: 'ToggleButton.bg.default',
          _notDisabled: {
            _hover: 'ToggleButton.bg.hover',
            _active: 'ToggleButton.bg.pressed',
          },
        },
        boxShadowColor: {
          base: 'ToggleButton.border.default',
          _notDisabled: {
            _hover: 'ToggleButton.border.hover',
            _active: 'ToggleButton.border.pressed',
          },
        },
      },
    },

    size: {
      sm: {
        borderRadius: 'ToggleButton.sm',
        gap: 'ToggleButton.sm.gap.label-toIcon',
        paddingBlock: 'ToggleButton.sm.padding.vert',
        paddingInline: 'ToggleButton.sm.padding.horz',
      },
      md: {
        borderRadius: 'ToggleButton.md',
        gap: 'ToggleButton.md.gap.label-toIcon',
        paddingBlock: 'ToggleButton.md.padding.vert',
        paddingInline: 'ToggleButton.md.padding.horz',
      },
      lg: {
        borderRadius: 'ToggleButton.lg',
        gap: 'ToggleButton.lg.gap.label-toIcon',
        paddingBlock: 'ToggleButton.lg.padding.vert',
        paddingInline: 'ToggleButton.lg.padding.horz',
      },
    },
  },
});
